import { put, takeEvery, all, call } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { setCourseFailed, searchCourseResult, clearError } from '../actions';
import { CoursesActionTypes } from '../types';

const { API_BASE_URL } = urls || {};

export function* search({ data }) {
  const { searchPattern, pageSize } = data;
  const url = `${API_BASE_URL}/courses?&pageSize=${
    pageSize || 10
  }&search=${searchPattern}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(clearError());
    yield put(searchCourseResult(response.raw));
  } else {
    yield put(setCourseFailed(response.message));
  }
}

export function* searchByStatus({ data }) {
  const { status } = data;
  const url = `${API_BASE_URL}/courses?status=${status.toLowerCase()}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(clearError());
    yield put(searchCourseResult(response.raw));
  } else {
    yield put(setCourseFailed(response.message));
  }
}

export function* searchByAdminLevel({ data }) {
  const { adminLevelItemId, pageSize } = data;
  const url = `${API_BASE_URL}/courses?&pageSize=${
    pageSize || 10
  }&adminLevelItemId=${adminLevelItemId}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(clearError());
    yield put(searchCourseResult(response.raw));
  } else {
    yield put(setCourseFailed(response.message));
  }
}

export function* onSearchCourse() {
  yield takeEvery(CoursesActionTypes.SEARCH_COURSE, search);
}
export function* onSearchByStatus() {
  yield takeEvery(CoursesActionTypes.FILTER_BY_STATUS, searchByStatus);
}
export function* onSearchByAdminLevel() {
  yield takeEvery(CoursesActionTypes.FILTER_BY_ADMIN_LEVEL, searchByAdminLevel);
}

export function* searchSagas() {
  yield all([
    call(onSearchCourse),
    call(onSearchByStatus),
    call(onSearchByAdminLevel),
  ]);
}
